import { typedHasProperty } from './typed-has-property';
export function getValueFromNestedKeys(inputObject, nestedKeys) {
    /**
     * Lots of as any casts in here because these types are, under the hood, pretty complex. Since
     * the inputs and outputs of this function are well typed, these internal as any casts do not
     * affect the external API of this function.
     */
    const keyToAccess = nestedKeys[0];
    if (!typedHasProperty(inputObject, keyToAccess)) {
        return undefined;
    }
    const currentValue = inputObject[keyToAccess];
    if (nestedKeys.length > 1) {
        return getValueFromNestedKeys(currentValue, nestedKeys.slice(1));
    }
    else {
        return currentValue;
    }
}
